import { Provider } from 'modules/transmission/types'

export default class TransmissionHelper {
  static isHotmartProvider = (provider: Provider) => [
    Provider.HOTMART,
    Provider.MUX_STUDIO_HOTMART
  ].includes(provider)
}
